import { RPCFactory } from '../utils/RequestUtil';
import React from 'react';
import { connect } from 'react-redux';
import { store } from '../store/Store';
import { GlobalStateAction } from '../actions/GlobalStateAction';

const mapStateToProps = (state) => ({ ...state.account });
export function withAccountList(Component) {
  class WithAccountListComponent extends React.Component {
    componentDidMount() {
      if (this.props.status === 'init') {
        this.getAccountList();
      }
    }
    getAccountList = () => {
      store.dispatch({
        type: GlobalStateAction.ACCOUNT_LIST_SEARCHING,
      });
      if (window.pageProps.authenticationWay === 'SSO_LOGIN') {
        RPCFactory.sso
          .getLoginUserList({
            loginName: window.pageProps.ssoMultiAccountLoginName,
            loginNameType: window.pageProps.ssoMultiAccountLoginType,
            limit: 100,
            offset: 0,
          })
          .done((data) => {
            store.dispatch({
              type: GlobalStateAction.SET_ACCOUNT_LIST,
              payload: {
                accountList: data.loginInfoItemVOList
                  ? data.loginInfoItemVOList
                  : [{ account_id: window.pageProps.uid, account_name: window.pageProps.companyName }],
              },
            });
          })
          .fail((ret, msg) => {
            window.alert(`获取账户列表错误：${msg}`);
          });
      } else if (window.pageProps.source == 'qw') {
        RPCFactory.account.qwPlatformGetLoginUserList().done((data) => {
          console.log(data.advertiserList);
          store.dispatch({
            type: GlobalStateAction.SET_ACCOUNT_LIST,
            payload: {
              accountList: data.advertiserList
                ? data.advertiserList
                : [{ account_id: window.pageProps.uid, account_name: window.pageProps.companyName }],
            },
          });
        })
        .fail((ret, msg) => {
          window.alert(`获取账户列表错误：${msg}`);
        });
      }
    };
    render() {
      return <Component {...this.props} accountList={this.props.accountList} />;
    }
  }

  return connect(mapStateToProps)(WithAccountListComponent);
}
